var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "leo-form-label-with-tip" },
    [
      _c("span", { staticClass: "leo-form-label-text" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _c(
        "el-tooltip",
        {
          attrs: {
            placement: "top",
            effect: "dark",
            "popper-class": "leo-knowledge-tip-popper"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "leo-tip-rich",
              attrs: { slot: "content" },
              slot: "content"
            },
            [_vm._v(_vm._s(_vm.tip))]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "el-icon-question leo-field-tip-icon" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1843012a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1843012a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/LeoFormLabelTip.vue
// module id = null
// module chunks = 